import React from 'react';
import { Link } from 'react-router-dom';
import './LinkList.css';

const LinkList = ({linkItems = []}) => (
  <ul className="link-list link-list--horizontal">
    {linkItems.map(link => {
      return (
        <li className="link-item">
          <Link to={link.to} className="simple-link">
            {link.text}
          </Link>
        </li>
      );
    })}
  </ul>
);

export default LinkList;



/** WEBPACK FOOTER **
 ** ./src/components/LinkList/index.js
 **/